import { render, staticRenderFns } from "./media-kit.vue?vue&type=template&id=bf589ff0&scoped=true&"
import script from "./media-kit.vue?vue&type=script&lang=js&"
export * from "./media-kit.vue?vue&type=script&lang=js&"
import style0 from "./media-kit.vue?vue&type=style&index=0&id=bf589ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf589ff0",
  null
  
)

export default component.exports